"use strict";
exports.__esModule = true;
var telegram_chart_1 = require("./telegram-chart");
var render_target_1 = require("./render-target/render-target");
var css_helpers_1 = require("./core/css-helpers");
var padding_1 = require("./core/padding");
var easing_functions_1 = require("./core/easing-functions");
var TelegramChartZoom = /** @class */ (function () {
    function TelegramChartZoom(chart, containerElement) {
        this.chart = chart;
        this.containerElement = containerElement;
        this.handleSize = telegram_chart_1.TelegramChart.pixelsToCanvasSize(20);
        this.handleBorserSize = telegram_chart_1.TelegramChart.pixelsToCanvasSize(2);
        this.minZoomWidth = telegram_chart_1.TelegramChart.pixelsToCanvasSize(10);
        this.fullWidth = 0;
        this.onAnimationFrameBound = this.onAnimationFrame.bind(this);
        this.leftOffsetAnimationUpdateBound = this.leftOffsetAnimationUpdate.bind(this);
        this.rightOffsetAnimationUpdateBound = this.rightOffsetAnimationUpdate.bind(this);
        chart.zoomControl = this;
        var canvas = chart.document.createElement('canvas');
        canvas.width = telegram_chart_1.TelegramChart.pixelsToCanvasSize(containerElement.getBoundingClientRect().width);
        canvas.height = telegram_chart_1.TelegramChart.pixelsToCanvasSize(containerElement.getBoundingClientRect().height);
        canvas.style.width = '100%';
        this.fullWidth = containerElement.getBoundingClientRect().width;
        containerElement.style.position = 'relative';
        containerElement.appendChild(canvas);
        this.renderTarget = new render_target_1.RenderTarget(chart);
        this.renderTarget.quality = 10;
        this.renderTarget.lineWidth = telegram_chart_1.TelegramChart.pixelsToCanvasSize(1);
        this.renderTarget.canvas = canvas;
        this.renderTarget.autoAdjustYMax = this.chart.mainRenderTarget.autoAdjustYMax;
        this.renderTarget.autoAdjustYMin = this.chart.mainRenderTarget.autoAdjustYMin;
        this.renderTarget.viewPortPadding = new padding_1.Padding();
        this.renderTarget.viewPortPadding.top = telegram_chart_1.TelegramChart.pixelsToCanvasSize(0);
        this.renderTarget.viewPortPadding.bottom = telegram_chart_1.TelegramChart.pixelsToCanvasSize(0);
        chart.addRenderTarget(this.renderTarget);
        this.leftOffsetX = this.fullWidth - this.handleSize - this.minZoomWidth;
        this.leftHandle = chart.document.createElement('div');
        this.leftHandle.className = 'telegram-chart-zoom-handle telegram-chart-zoom-handle-left';
        this.leftHMouseMoveHandlerBound = this.onLeftHandleMouseMove.bind(this);
        this.leftHandle.addEventListener('touchstart', this.onLeftHandleMouseDown.bind(this));
        this.leftHandle.addEventListener('mousedown', this.onLeftHandleMouseDown.bind(this));
        containerElement.appendChild(this.leftHandle);
        this.leftOverlay = chart.document.createElement('div');
        this.leftOverlay.className = 'telegram-chart-zoom-overlay telegram-chart-zoom-overlay-left';
        containerElement.appendChild(this.leftOverlay);
        this.handleSize = this.leftHandle.getBoundingClientRect().width;
        this.rightOffsetX = this.fullWidth - this.handleSize;
        this.rightHandle = chart.document.createElement('div');
        this.rightHandle.className = 'telegram-chart-zoom-handle telegram-chart-zoom-handle-right';
        this.rightHandleMouseMoveHandlerBound = this.onRightHandleMouseMove.bind(this);
        this.rightHandle.addEventListener('touchstart', this.onRightHandleMouseDown.bind(this));
        this.rightHandle.addEventListener('mousedown', this.onRightHandleMouseDown.bind(this));
        containerElement.appendChild(this.rightHandle);
        this.rightOverlay = chart.document.createElement('div');
        this.rightOverlay.className = 'telegram-chart-zoom-overlay telegram-chart-zoom-overlay-right';
        containerElement.appendChild(this.rightOverlay);
        this.centralHandle = chart.document.createElement('div');
        this.centralHandle.className = 'telegram-chart-zoom-handle telegram-chart-zoom-handle-center';
        this.centralHandle.style.width = this.minZoomWidth + "px";
        this.centralHandle.style.transformOrigin = 'top left';
        this.centralHandleMouseMoveHandlerBound = this.onCentralHandleMouseMove.bind(this);
        this.centralHandle.addEventListener('touchstart', this.onCentralHandleMouseDown.bind(this));
        this.centralHandle.addEventListener('mousedown', this.onCentralHandleMouseDown.bind(this));
        containerElement.appendChild(this.centralHandle);
        this.chart.document.addEventListener('mouseup', this.onHandleMouseUp.bind(this));
        this.chart.document.addEventListener('touchend', this.onHandleMouseUp.bind(this));
        //this.setZoom(70, 30);
    }
    TelegramChartZoom.prototype.onResize = function () {
        this.fullWidth = this.containerElement.getBoundingClientRect().width;
        var renderTargetDataFrame = this.chart.mainRenderTarget.dataFrame.get(this.chart.currentZoomState);
        var renderTargetViewPortDataFrame = this.chart.mainRenderTarget.viewPortDataFrame.get(this.chart.currentZoomState);
        this.animateToValues(renderTargetViewPortDataFrame.x.min, renderTargetViewPortDataFrame.x.max, renderTargetDataFrame.x);
        this.renderTarget.canvas.width = telegram_chart_1.TelegramChart.pixelsToCanvasSize(this.containerElement.getBoundingClientRect().width);
        this.renderTarget.canvas.height = telegram_chart_1.TelegramChart.pixelsToCanvasSize(this.containerElement.getBoundingClientRect().height);
    };
    TelegramChartZoom.prototype.onLeftHandleMouseDown = function (event) {
        this.leftHandleStartPosX = this.leftOffsetX;
        this.dragMouseStartPosX = event instanceof MouseEvent ? event.pageX : event.touches[0].pageX;
        this.chart.document.addEventListener('touchmove', this.leftHMouseMoveHandlerBound);
        this.chart.document.addEventListener('mousemove', this.leftHMouseMoveHandlerBound);
        if (event.cancelable !== false) {
            event.preventDefault();
        }
        return false;
    };
    TelegramChartZoom.prototype.onRightHandleMouseDown = function (event) {
        this.rightHandleStartPosX = this.rightOffsetX;
        this.dragMouseStartPosX = event instanceof MouseEvent ? event.pageX : event.touches[0].pageX;
        this.chart.document.addEventListener('touchmove', this.rightHandleMouseMoveHandlerBound);
        this.chart.document.addEventListener('mousemove', this.rightHandleMouseMoveHandlerBound);
        if (event.cancelable !== false) {
            event.preventDefault();
        }
        return false;
    };
    TelegramChartZoom.prototype.onCentralHandleMouseDown = function (event) {
        this.leftHandleStartPosX = this.leftOffsetX;
        this.rightHandleStartPosX = this.rightOffsetX;
        this.centralHandleStartPosX = this.leftOffsetX + this.handleSize;
        this.dragMouseStartPosX = event instanceof MouseEvent ? event.pageX : event.touches[0].pageX;
        this.chart.document.addEventListener('touchmove', this.centralHandleMouseMoveHandlerBound);
        this.chart.document.addEventListener('mousemove', this.centralHandleMouseMoveHandlerBound);
        if (event.cancelable !== false) {
            event.preventDefault();
        }
        return false;
    };
    TelegramChartZoom.prototype.onLeftHandleMouseMove = function (event) {
        var diffX = (event instanceof MouseEvent ? event.pageX : event.touches[0].pageX) - this.dragMouseStartPosX;
        var newX = this.leftHandleStartPosX + diffX;
        this.leftOffsetX = newX;
        if (this.leftOffsetX < 0) {
            this.leftOffsetX = 0;
        }
        if (this.leftOffsetX + this.handleSize + this.minZoomWidth > this.fullWidth) {
            this.leftOffsetX = this.fullWidth - this.handleSize - this.minZoomWidth;
        }
        if (this.leftOffsetX + this.handleSize + this.minZoomWidth > this.rightOffsetX + this.handleSize) {
            this.rightOffsetX = this.leftOffsetX + this.minZoomWidth;
        }
        this.calculateZoom();
        this.chart.requestRender();
        requestAnimationFrame(this.onAnimationFrameBound);
        // if (event.cancelable !== false) {
        //     event.preventDefault();
        // }
        return false;
    };
    TelegramChartZoom.prototype.onRightHandleMouseMove = function (event) {
        var diffX = (event instanceof MouseEvent ? event.pageX : event.touches[0].pageX) - this.dragMouseStartPosX;
        var newX = this.rightHandleStartPosX + diffX;
        this.rightOffsetX = newX;
        if (this.rightOffsetX < this.minZoomWidth) {
            this.rightOffsetX = this.minZoomWidth;
        }
        if (this.rightOffsetX > this.fullWidth - this.handleSize) {
            this.rightOffsetX = this.fullWidth - this.handleSize;
        }
        if (this.rightOffsetX < this.leftOffsetX + this.minZoomWidth) {
            this.leftOffsetX = this.rightOffsetX - this.minZoomWidth;
        }
        this.calculateZoom();
        this.chart.requestRender();
        requestAnimationFrame(this.onAnimationFrameBound);
        // if (event.cancelable !== false) {
        //     event.preventDefault();
        // }
        return false;
    };
    TelegramChartZoom.prototype.onCentralHandleMouseMove = function (event) {
        var diffX = (event instanceof MouseEvent ? event.pageX : event.touches[0].pageX) - this.dragMouseStartPosX;
        var newLeftHandleX = this.leftHandleStartPosX + diffX;
        var newRightHandleX = this.rightHandleStartPosX + diffX;
        this.leftOffsetX = newLeftHandleX;
        if (this.leftOffsetX < 0) {
            this.leftOffsetX = 0;
        }
        if (this.leftOffsetX + this.handleSize + this.minZoomWidth > this.fullWidth) {
            this.leftOffsetX = this.fullWidth - this.handleSize - this.minZoomWidth;
        }
        this.rightOffsetX = newRightHandleX;
        if (this.rightOffsetX < this.minZoomWidth) {
            this.rightOffsetX = this.minZoomWidth;
        }
        if (this.rightOffsetX > this.fullWidth - this.handleSize) {
            this.rightOffsetX = this.fullWidth - this.handleSize;
        }
        if (this.rightOffsetX < this.leftOffsetX + this.minZoomWidth) {
            this.leftOffsetX = this.rightOffsetX - this.minZoomWidth;
        }
        this.calculateZoom();
        this.chart.requestRender();
        requestAnimationFrame(this.onAnimationFrameBound);
        // if (event.cancelable !== false) {
        //     event.preventDefault();
        // }
        return false;
    };
    TelegramChartZoom.prototype.onAnimationFrame = function () {
        this.leftHandle.style.transform = css_helpers_1.CssHelpers.getTranslateX(this.leftOffsetX);
        var leftScaleFactor = (this.leftOffsetX + 10) / this.fullWidth;
        this.leftOverlay.style.transform = css_helpers_1.CssHelpers.getTranslateXScaleX(0, leftScaleFactor);
        var centralScaleFactor = (this.rightOffsetX - this.leftOffsetX + this.handleSize - (this.handleBorserSize * 2)) / this.minZoomWidth;
        this.centralHandle.style.transform = css_helpers_1.CssHelpers.getTranslateXScaleX(this.leftOffsetX + this.handleBorserSize, centralScaleFactor);
        this.rightHandle.style.transform = css_helpers_1.CssHelpers.getTranslateX(this.rightOffsetX);
        var rightScaleFactor = (this.fullWidth - this.rightOffsetX - this.handleSize + 10) / this.fullWidth;
        this.rightOverlay.style.transform = css_helpers_1.CssHelpers.getTranslateXScaleX(0, rightScaleFactor);
    };
    TelegramChartZoom.prototype.onHandleMouseUp = function () {
        this.chart.document.removeEventListener('touchmove', this.leftHMouseMoveHandlerBound);
        this.chart.document.removeEventListener('touchmove', this.rightHandleMouseMoveHandlerBound);
        this.chart.document.removeEventListener('touchmove', this.centralHandleMouseMoveHandlerBound);
        this.chart.document.removeEventListener('mousemove', this.leftHMouseMoveHandlerBound);
        this.chart.document.removeEventListener('mousemove', this.rightHandleMouseMoveHandlerBound);
        this.chart.document.removeEventListener('mousemove', this.centralHandleMouseMoveHandlerBound);
        return false;
    };
    TelegramChartZoom.prototype.calculateZoom = function () {
        var leftHandleOffsetFactor = this.leftOffsetX / this.fullWidth;
        var rightHandleOffsetFactor = (this.rightOffsetX + this.handleSize) / this.fullWidth;
        var dataFrame = this.chart.dataFrame.get(this.chart.currentZoomState);
        var xFrame = dataFrame.x.max - dataFrame.x.min;
        var xMinValue = leftHandleOffsetFactor * xFrame;
        var xMaxValue = rightHandleOffsetFactor * xFrame;
        var renderTargetViewPortDataFrame = this.chart.mainRenderTarget.viewPortDataFrame.get(this.chart.currentZoomState);
        renderTargetViewPortDataFrame.x.min = dataFrame.x.min + xMinValue;
        renderTargetViewPortDataFrame.x.max = dataFrame.x.min + xMaxValue;
        this.chart.mainRenderTarget.viewportChanged = true;
        this.chart.recalculateYViewport = true;
    };
    TelegramChartZoom.prototype.setZoom = function (offsetInPercents, zoomInPercents) {
        var width = this.fullWidth;
        this.leftOffsetX = width * offsetInPercents / 100;
        this.rightOffsetX = width * (offsetInPercents + zoomInPercents) / 100;
        this.rightOffsetX -= this.handleSize;
        this.calculateZoom();
        requestAnimationFrame(this.onAnimationFrameBound);
        this.chart.requestRender();
    };
    TelegramChartZoom.prototype.leftOffsetAnimationUpdate = function (o, c, value) {
        this.leftOffsetX = value;
        this.onAnimationFrame();
    };
    TelegramChartZoom.prototype.rightOffsetAnimationUpdate = function (o, c, value) {
        this.rightOffsetX = value;
        this.onAnimationFrame();
    };
    TelegramChartZoom.prototype.animateToValues = function (xMinValue, xMaxValue, xMinMax) {
        var width = this.fullWidth;
        var frame = xMinMax.max - xMinMax.min;
        var leftFactor = (xMinValue - xMinMax.min) / frame;
        var rightFactor = (xMaxValue - xMinMax.min) / frame;
        var newLeftOffsetX = width * leftFactor;
        var newRightOffsetX = (width * rightFactor) - this.handleSize;
        var leftAnimation = this.chart.getAnimation();
        leftAnimation.animatedObject = this;
        leftAnimation.duration = this.chart.animationTimeMs;
        leftAnimation.easingFunction = easing_functions_1.EasingFunctions.easeInOutQuart;
        leftAnimation.startValue = this.leftOffsetX;
        leftAnimation.endValue = newLeftOffsetX;
        leftAnimation.update = this.leftOffsetAnimationUpdateBound;
        this.chart.addAnimation(leftAnimation);
        var rightAnimation = this.chart.getAnimation();
        rightAnimation.animatedObject = this;
        rightAnimation.duration = this.chart.animationTimeMs;
        rightAnimation.easingFunction = easing_functions_1.EasingFunctions.easeInOutQuart;
        rightAnimation.startValue = this.rightOffsetX;
        rightAnimation.endValue = newRightOffsetX;
        rightAnimation.update = this.rightOffsetAnimationUpdateBound;
        this.chart.addAnimation(rightAnimation);
    };
    return TelegramChartZoom;
}());
exports.TelegramChartZoom = TelegramChartZoom;
//# sourceMappingURL=telegram-chart-zoom.js.map